// @theme component
import { getFidoAuthenticators } from './server';
import { PLAYER_NEVIS_TAG_VALUES } from './constants';
import { ISetPlayerTagsRequestData } from 'js/hooks/socket/hooks/useSetPlayerTags/types';
import { IGetPlayerTagsRequestData, IGetPlayerTagsResponseData } from 'js/hooks/socket/hooks/useGetPlayerTags/types';

export const fetchNevisPasskeys = async () => {
    try {
        return await getFidoAuthenticators();
    } catch (error) {
        return false;
    }
};

export const getPlayerNevisTag = async (
    getPlayerTags: (request?: IGetPlayerTagsRequestData) => Promise<IGetPlayerTagsResponseData>,
    setValue: (value: boolean) => void,
    tagName: string
) => {
    const response = await getPlayerTags({ tagName });
    const tagValue = response.tags?.[0]?.value?.toLowerCase() || '';

    setValue(Object.values(PLAYER_NEVIS_TAG_VALUES).includes(tagValue as PLAYER_NEVIS_TAG_VALUES));
};

export const setPlayerEnrollmentCompleted = async (
    setPlayerTags: (request: ISetPlayerTagsRequestData) => void,
    tagName: string
) => {
    await setPlayerTags({
        tags: [{
            name: tagName,
            value: PLAYER_NEVIS_TAG_VALUES.COMPLETED,
            type: 'text'
        }]
    });
};
